/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint array-element-newline: ["error", "never"] */
import React from 'react';
import {
    object, func, arrayOf, shape, string, number, bool,
} from 'prop-types';
import Edit from '@material-ui/icons/Edit';
import AddCircle from '@material-ui/icons/AddCircle';
import { withStyles } from '@material-ui/core/styles';
import { formatPhoneNumber } from '../../../../utils/formater';

const styles =  ({
    billingAddressWrap: {
        minHeight: '123px',
        wordWrap: 'break-word',
    },
    verticalAlignMiddle: {
        verticalAlign: 'middle',
    },
    messageWidth: {
        width: '150px',
    },
});

const EmptyBillingAddressTemplate = (classes, onEdit, wallet) => (
    <div className="min-height-15x">
        <p className={`bold padding-top-4x padding-bottom-4x padding-left no-wrap ${classes.messageWidth}`}>
            You do not have a billing address on file.
        </p>
        <div className="blue-color align-right padding-right padding-bottom position-absolute-bottom">
            <span className="link-button" role="presentation" onClick={() => onEdit([], wallet, 'desktop')}>
                <AddCircle className={`link-icon ${classes.verticalAlignMiddle}`} />
                <span className="link-label">Add</span>
            </span>
        </div>
    </div>
);

const DesktopAccountBillingInfo = ({
    billingAddress, wallet, countries, onEdit, classes,
}) => {
    if (billingAddress.length === 0) {
        return (
            EmptyBillingAddressTemplate(classes, onEdit, wallet)
        );
    }
    const [{ FirstName }] = billingAddress;
    return (
        <>
            {FirstName ? (
                billingAddress.map((address) => (
                    address?.FirstName ? (
                        <React.Fragment key={address.AddressBookEntryId}>
                            <div className="padding-right padding-top gray-color align-right small">Default</div>
                            <div className="padding">
                                <div className={classes.billingAddressWrap}>
                                    <div className="bold">
                                        {address.FirstName} {address.LastName}
                                    </div>
                                    <div className="bold">{address.EmployerName}</div>
                                    <div className="bold">
                                        {address.Addresses?.[0]?.AddressLineOne}
                                        {address.Addresses?.[0]?.AddressLineTwo
                                            ? `, ${address.Addresses?.[0]?.AddressLineTwo}`
                                            : ''}
                                    </div>
                                    <div className="bold">
                                        {[
                                            address.Addresses?.[0]?.City, address.Addresses?.[0]?.StateProvince, address.Addresses?.[0]?.PostalCode,
                                        ].join(', ')}
                                    </div>
                                    <div className="bold">
                                        {
                                            countries.filter((c) => c.id === address.Addresses?.[0]?.Country)[0]?.name
                                        }
                                    </div>
                                    <div className="bold">{formatPhoneNumber(address.PhoneNumber)}</div>

                                </div>
                                <div className="blue-color align-right">
                                    <span className="link-button" role="presentation" onClick={() => onEdit([address], wallet, 'desktop')}>
                                        <Edit className={`link-icon ${classes.verticalAlignMiddle}`} />
                                        <span className="link-label">Edit</span>
                                    </span>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : ''
                ))
            ) : (
                EmptyBillingAddressTemplate(classes, onEdit, wallet)
            )}
        </>
    );
};

DesktopAccountBillingInfo.defaultProps = {
    wallet: [],
    billingAddress: [{
        Addresses: '',
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        EmployerName: '',
    }],
};

DesktopAccountBillingInfo.propTypes = {
    billingAddress: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            FirstName: string,
            LastName: string,
            RelationShip: string,
            NickName: string,
            LastUpdateDate: string,
            PhoneNumber: string,
            EmployerName: string,
            NumberOfAddresses: number,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    IsPartialMatch: bool,
                    IsUnknownAddress: bool,
                    Latitude_degrees: number,
                    Longitude_degrees: number,
                    IsBillingAddress: bool,
                    ContactId: number,
                }),
            ),
        }),
    ),
    wallet: arrayOf(
        shape({
            walletId: string.isRequired,
            cardType: string.isRequired,
            payType: string.isRequired,
            cardHolderName: string.isRequired,
            cardNumber: string.isRequired,
            lastFourDigits: string.isRequired,
            expiryDate: string.isRequired,
            status: string,
            subsIndicator: string,
        }),
    ),
    countries: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    onEdit: func.isRequired,
    classes: object.isRequired,
};

export default (withStyles(styles)(DesktopAccountBillingInfo));
